"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValueWrapper = exports.UntoggledValue = void 0;
const styles_1 = require("@mui/material/styles");
const Typography_1 = __importDefault(require("@mui/material/Typography"));
exports.UntoggledValue = (0, styles_1.styled)(Typography_1.default)(({ theme }) => ({
    color: theme.palette.grayScale.gray2,
    fontWeight: "bold",
    cursor: "pointer",
}));
exports.ValueWrapper = (0, styles_1.styled)("span")({
    display: "flex",
    alignItems: "center",
    button: {
        marginLeft: "12px",
    },
});
